import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { Select as CoreSelect } from "@sparefoot/react-commons";
import { Text } from "components/core/Typography";

import "./Select.scss";

const Select = ({
	label,
	id,
	options,
	onChange = () => {},
	defaultValue = null,
	className = null,
	// Unlike `className` above, lands on the native <select>, not the <label>
	selectClassName = null,
	labelProps = {},
	getRef = null,
	useThinSelect = false,
	...rest
}) => (
	<label
		htmlFor={id}
		className={classnames("sf-select", className, {
			"thin-select": !!useThinSelect
		})}
	>
		<Text
			last
			size="small"
			color="gray"
			{...labelProps}
		>
			{label}
		</Text>
		<CoreSelect
			getRef={getRef}
			id={id}
			onChange={onChange}
			defaultValue={defaultValue}
			options={options}
			className={selectClassName}
			{...rest}
		/>
	</label>
);

Select.propTypes = {
	getRef: PropTypes.object,
	label: PropTypes.string.isRequired,
	labelProps: PropTypes.object,
	className: PropTypes.string,
	selectClassName: PropTypes.string,
	id: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	defaultValue: PropTypes.string,
	useThinSelect: PropTypes.bool,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired
		})
	).isRequired
};

export default Select;
